export default "__VITE_ASSET__CEySQff7__"